import React from "react";
import "./DetailCards.scss";

const cards = [
  {
    label: "locations",
    icon: "/dataguardIcons/locationWhite.svg",
    name: "Locations",
  },
  {
    label: "publicdata",
    icon: "/dashboardIcons/publicActiveWhite.svg",
    name: "Public Data",
  },
  { label: "roles", icon: "/dataguardIcons/rolesWhite.svg", name: "Roles" },
  // { label: "users", icon: "/dataguardIcons/usersWhite.svg", name: "Users" },
  {
    label: "behaviormodels",
    icon: "/dataguardIcons/behaviorWhite.svg",
    name: "Behaviour Model",
  },
];

const DetailCards = ({ onSelect, selected }) => {
  return (
    <div className="detail-cards-container">
      {cards.map((card) => (
        <div
          key={card.label}
          className={`detail-card ${
            (card.label === "roles" &&
              (selected === "roles" || selected === "users")) ||
            selected === card.label
              ? "active"
              : ""
          } ${card.label}`}
          onClick={() => onSelect(card.label)}
        >
          <div className="detail-card-icon">
            <img src={card.icon} alt={card.name} />
          </div>
          <div className="detail-card-label">
            {card.label === "roles" && selected === "users"
              ? "Users"
              : card.name}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DetailCards;
